import React from 'react'
import './Splitter.css'

function Splitter({visible = true}) {
  return (
    <div className={`splitter ${visible ? "" : "hidden"}`}></div>
  )
}

export default Splitter